import { styled } from '@mui/material';
import Link from 'next/link';

const StyledTopLink = styled(Link, props => <Link {...props} />)({
  color: 'black',
  fontSize: '0.75rem',
  cursor: 'pointer',
});

export default StyledTopLink;
